/**
 * @desc 根据店铺编号获取店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.getByShopNo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getByShopNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
